import React,{useEffect, useState} from "react"
import {Container,Label,Spinner,Row,Col, CardBody,Card, CardTitle,CardHeader,CardText} from "reactstrap"
import "../../assets/scss/manual/manual.scss";
import toast from 'react-hot-toast';
import axios from "axios";
import AppConfig from "constants/config";
import { useLocation, useNavigate } from "react-router-dom";
import {Helmet} from "react-helmet";
import Breadcrumb from "../../components/Common/Breadcrumb";
import Layout from "components/VerticalLayout";

const Modules = () => {
    const [loading, setLoading] = useState(true);
    const [selectedModule, setSelectedModules] = useState([])
    const navigate = useNavigate();
    const location = useLocation();
    const [accountData, setAccountData] = useState({});
    const [id, setId] = useState('');
    const [moduleList, setModuleList] = useState([])
    
    const updateModules = async() => {
        setLoading(true);
        try {
            const {data} = await axios.post(`${AppConfig.baseUrl}/customer/updateModule`, {id: accountData.customer_id._id, modules : selectedModule},{
              headers: { token: localStorage.getItem("token") }
            });
            if(!data.error){
                toast.success('Modules updated successfully');
                navigate("/accounts/modules")
            }
            else{
                throw new Error(data.title);
            }
        } catch (error) {
            toast.error(error.message || 'Something went wrong');
        }
        setLoading(false);
    }

    useEffect(() => {
        setId((location.search).replace('?', ''));
    }, [])

    useEffect(() => {
        if(id){
            getAccountData();
            getModules()
        }
    },[id])

    const getAccountData = async () => {
        setLoading(true)
        try {
            const {data} = await axios.get(`${AppConfig.baseUrl}/customer/getDetails?id=${id}`,{
                headers: { token: localStorage.getItem("token") }
            });
            if(!data.error){
                setAccountData(data.custData || {})
            }
            else{
                throw new Error(data.title);
            }
        } catch (error) {
            toast.error(error.message || 'Something went wrong');
            navigate("/accounts")
        }
        setLoading(false)
    }

    const getModules = async() =>{
        try{
            const {data} = await axios.post(`${AppConfig.baseUrl}/module/listModule`,{},{
                headers: { token: localStorage.getItem("token") }
            })
            if(!data.error){
                setModuleList(data.data)
            }else{
                throw new Error(data.title);
            }
        }catch(error){
            toast.error(error.message || "something went wrong");
        }
    }

    useEffect(()=>{
        setSelectedModules(accountData && accountData.customer_id && accountData.customer_id.modules ? accountData.customer_id.modules : [])
    },[accountData])

    const handleModuleChange = (e)=>{
        if(selectedModule.includes(e.target.name)){
            let data = selectedModule.filter(i => i != e.target.name)
            setSelectedModules(data)
        }else{
            setSelectedModules([...selectedModule,e.target.name])
        }
    }

    return (
        <Layout>
            <div className="page-content">
                <Helmet>
                        <title>LeaseVista | Modules</title>
                </Helmet>
                <Container fluid>
                    <Breadcrumb title="Modules" breadcrumbItem="Modules"/>
                    <Card>
                        <CardTitle className="mt-4 ms-3">Update Modules</CardTitle><hr/>
                        <CardBody>

                    {
                        loading ?
                            <div style={{textAlign: 'center'}}><Spinner color="primary" className="txt-theme-color" /></div>
                        :
                        <Row>
                            {moduleList.map(m => 
                                <Col lg={4} key={m._id}>
                                <Card outline color={`${selectedModule.includes(m.tag) ? 'theme-color' : 'secondary'}`} className="border">
                                <CardHeader className="bg-transparent">
                                    <h5 className={`my-0 ${selectedModule.includes(m.tag) ? 'txt-theme-color' : 'text-secondary'}`}>
                                        <div className="d-flex">
                                            <div className="form-check form-switch mt-2">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input switch-icon-color"
                                                    id={m.tag}
                                                    name={m.tag}
                                                    checked = {selectedModule.includes(m.tag)}
                                                    onChange={handleModuleChange}
                                                />
                                            </div>
                                            <div >
                                                <Label for={m.tag} className="col-form-label">
                                                {m.title}
                                                </Label>
                                            </div>
                                        </div>
                                    </h5>
                                </CardHeader>
                                <CardBody>
                                    <CardText className={`${selectedModule.includes(m.tag) ? 'txt-theme-color' : 'text-secondary'}`}>
                                        {m.description}
                                    </CardText>
                                </CardBody>
                                </Card>
                            </Col>
                            )}
                        </Row>
                    }
                        </CardBody>
                    <hr />
                    <Col>
                        <button type="button" onClick={updateModules} disabled={loading} className="btn bg-theme-color btn-md mb-4 ms-3 mt-2" style={{float:'left'}}>
                            SUBMIT
                        </button>
                    </Col>
                    </Card>
                    
                </Container>
            </div>
        </Layout>
    )
}

export default Modules